import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "../axiosConfig";
import { encode } from "base-64";

const setCookie = (cName, cValue, expireTime) => {
	document.cookie = `${cName}=${cValue};max-age=${expireTime};path=/;`;
};

const deleteCookie = (cname) => {
	document.cookie = cname + "=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

export const authToken = createAsyncThunk("auth/authToken", async ({ token }) => {
	const response = await apiConfig
		.post(`/auth/signin?token=${token}`, "", {
			noHeader: true,
		})
		.catch((error) => {
			return error && error.response && error.response;
		});

	const data = await response.data;

	return data;
});

export const googleLogin = createAsyncThunk("auth/google", async ({ token }) => {
	const response = await apiConfig
		.post("auth/signin", "", {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Basic ${token}`,
			},
			noHeader: true,
		})
		.catch((error) => {
			return error && error.response && error.response;
		});

	const data = await response.data;

	return data;
});

export const loginUser = createAsyncThunk("auth/loginUser", async ({ username, password }) => {
	const token = encode(username + ":" + password);

	const response = await apiConfig
		.post("auth/signin", "", {
			headers: {
				"Content-Type": "application/json",
				Authorization: `Basic ${token}`,
			},
			noHeader: true,
		})
		.catch((error) => {
			return error && error.response && error.response;
		});

	const data = await response.data;

	return data;
});

export const logoutUser = createAsyncThunk("auth/logoutUser", async () => {
	const response = await apiConfig.delete("auth/signout");
	const data = await response.data;
	return data;
});

export const userDetail = createAsyncThunk("auth/user/me", async () => {
	const response = await apiConfig.get("auth/user/me").catch((error) => {
		return error && error.response && error.response;
	});
	const data = await response.data;
	return data;
});

const initialAuthenticationState = {
	isAuthenticated: false,
	userRoles: [],
	username: "",
	email: "",
	name: "",
};

const authSlice = createSlice({
	name: "auth",
	initialState: initialAuthenticationState,
	reducers: {
		login(state) {
			state.isAuthenticated = true;
		},
		logout(state) {
			state.isAuthenticated = false;
		},
	},
	extraReducers: {
		[googleLogin.fulfilled]: (state, action) => {
			if (!action.payload || !action.payload.data || action.payload.status !== "OK") {
				return;
			}

			const loginToken = action.payload.data && action.payload.data.refresh_token;
			const expiredIn = action.payload.data && action.payload.data.expired_in;
			setCookie("loginToken", loginToken, expiredIn);

			state.isAuthenticated = true;
		},
		[loginUser.fulfilled]: (state, action) => {
			if (!action.payload || !action.payload.data || action.payload.status !== "OK") {
				return;
			}

			const loginToken = action.payload.data && action.payload.data.refresh_token;
			const expiredIn = action.payload.data && action.payload.data.expired_in;
			setCookie("loginToken", loginToken, expiredIn);

			state.isAuthenticated = true;
		},
		[authToken.fulfilled]: (state, action) => {
			if (!action.payload || !action.payload.data || action.payload.status !== "OK") {
				return;
			}

			state.isAuthenticated = true;
		},
		[logoutUser.fulfilled]: (state, action) => {
			deleteCookie("loginToken");
			state.isAuthenticated = false;
		},
		[authToken.rejected]: (state, action) => {
			deleteCookie("loginToken");
			state.isAuthenticated = false;
		},
		[userDetail.fulfilled]: (state, action) => {
			if (!action.payload || !action.payload.data || action.payload.status !== "OK") {
				return;
			}

			state.isAuthenticated = true;
			state.userRoles = action.payload.data && action.payload.data.roles;
			state.username = action.payload.data && action.payload.data.username;
			state.email = action.payload.data && action.payload.data.email;
			state.name = action.payload.data && action.payload.data.name;
		},
	},
});

export const authActions = authSlice.actions;

export default authSlice.reducer;
